<template>
  <div class="page">
    <!-- header -->
    <xh-header />

    <!-- banner -->
    <ny-banner v-if="banner.length" :banner="banner[0]" />

    <!-- 单页 -->
    <single-page />

    <!-- footer -->
    <xh-footer />
  </div>
</template>
<script>
import XhHeader from '../../reveals/xh-header.vue'
import XhFooter from '../../reveals/xh-footer.vue'
import NyBanner from '../../sections/ny-banner.vue'
import SinglePage from '../../sections/single-page.vue'
import { getBanner } from '@/service/apis/common'

export default {
  components: {
    XhHeader,
    XhFooter,
    NyBanner,
    SinglePage
  },
  name: 'About',
  data () {
    return {
      banner: []
    }
  },

  created() {
    getBanner(this).then(data => {
      // banner 11
      if (data[12]) {
        this.banner = [...data[12]]
      }
    })
  }
}
</script>
<style scoped>
.detail {
  padding-top: 12px;
  height: auto;
  overflow: hidden;
}

.detail .content {
  padding: 12px 0;
  padding-bottom: 48px;
  color: #666;
  min-height: 250px;
  line-height: 28px;
}
.detail .content img {
  max-width: 100%;
}
</style>
